export default __webpack_public_path__ + "static/media/eye.28d3c51a.png";